import { useMemo } from 'react'
import { GRUPOS_USUARIOS_ATIVOS_QUERY } from '../../modules/grupo-usuarios-core/data/grupo-usuarios-ativos-query'
import { useQuery } from '@tanstack/react-query'
import { GruposUsuariosQueryQuery } from '../types/graphql'
import { request } from '../utils/request'

export interface GrupoUsuario {
  id: string
  nome: string
}

export const useGruposUsuariosAtivos = () => {
  const { data: { gruposUsuariosAtivos = [] } = {}, isLoading } = useQuery({
    queryKey: ['gruposUsuariosAtivos'],
    queryFn: async () =>
      await request<GruposUsuariosQueryQuery>(GRUPOS_USUARIOS_ATIVOS_QUERY)
  })

  const gruposOptions = useMemo(
    () =>
      (gruposUsuariosAtivos ?? []).map(grupo => ({
        value: grupo?.id,
        label: grupo?.nome,
        favorite: grupo?.favorito
      })),
    [gruposUsuariosAtivos]
  )

  return {
    grupos: gruposUsuariosAtivos,
    gruposOptions,
    hasGrupos: (gruposUsuariosAtivos ?? []).length > 0,
    loading: isLoading
  }
}
